import React from 'react'
import CheckInApp from '../src/pages/CheckInApp/CheckInApp'


const revampCheckInApp = () => {
  return (
    <div>
       <CheckInApp/> 
    </div>
  )
}

export default revampCheckInApp